import { useClient } from '../../../context/ClientStatusContext';
import { ClientStatus } from '../../../model/ClientStatus';
import PredpisCudziJazyk from '../../../model/PredpisCudziJazyk';
import { getPredpisyCudziJazykPage } from '../../../client/predpisyClient';

interface ReturnType {
  data: PredpisCudziJazyk;
  status: ClientStatus;
}

export default (
  id: string|undefined,
): ReturnType => {
  const {
    data,
    status,
  } = useClient(
    () => getPredpisyCudziJazykPage(id),
    [],
  );

  return <ReturnType>{
    data,
    status,
  };
};
